import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { isMobile } from '../../../utils/device-utils';
import { makeClassNames } from '../../../utils/styles';
import AdditiveFilter, { IAdditiveFilter } from '../../organisms/additive-filter/additive-filter';
import TennisCalendarTable, { ITennisTableCalendar } from '../../organisms/tennis-calendar-table/tennis-calendar-table';

import { useTennisCalendarFilters } from './tennis-circuits-calendar-hooks';
import './tennis-circuits-calendar.scss';

export interface ITennisCircuitsCalendar extends IComponent {
  calendar: ITennisTableCalendar[];
  hasCircuitFilter: boolean;
  calendarFilterModel: Omit<IAdditiveFilter, 'onChange'>;
}

const classNames = () =>
  makeClassNames({
    TennisCircuitsCalendar: 'tennis-circuits-calendar',
    competition: 'tennis-circuits-calendar--competition',
  });

const TennisCircuitsCalendar = ({ calendar, hasCircuitFilter, calendarFilterModel }: ITennisCircuitsCalendar) => {
  const cn = classNames();

  const { onChangePrimary, onChangeSecondary, seriesFilteredCalendar, completeFilteredCalendar } =
    useTennisCalendarFilters({ calendar, calendarFilterModel });

  if (!hasCircuitFilter) {
    return isMobile() ? (
      <TennisCalendarTable calendar={calendar} />
    ) : (
      <div className={cn.TennisCircuitsCalendar}>
        <AdditiveFilter {...{ ...calendarFilterModel, onChange: onChangeSecondary }} />
        <TennisCalendarTable calendar={seriesFilteredCalendar} />
      </div>
    );
  }

  return (
    <div className={cn.TennisCircuitsCalendar}>
      <AdditiveFilter {...{ ...calendarFilterModel, onChange: onChangePrimary }} />
      <TennisCalendarTable calendar={completeFilteredCalendar} />
    </div>
  );
};

export default TennisCircuitsCalendar;
